import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from 'src/app/utils/config/config.service';
import { Observable } from 'rxjs';
import { SesionService } from 'src/app/utils/sesion/sesion.service';

@Injectable({
  providedIn: 'root'
})
export class RegionService {
  controller: string = "region/";

  constructor(
    private http: HttpClient,
    private config: ConfigService,
    private sesion: SesionService
  ) { }

  getRegiones(): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + "index", this.sesion.headers);
  }

  buscarRegion(idRegion: number, regiones: any[]) {
    return regiones.find(region => region.id == idRegion);
  }
}
